import { render, staticRenderFns } from "./BaseLoadingSpinner.vue?vue&type=template&id=ff6ee454&scoped=true"
import script from "./BaseLoadingSpinner.vue?vue&type=script&lang=js"
export * from "./BaseLoadingSpinner.vue?vue&type=script&lang=js"
import style0 from "./BaseLoadingSpinner.vue?vue&type=style&index=0&id=ff6ee454&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6ee454",
  null
  
)

export default component.exports